import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

class DataLayer extends WebComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  didMount() {
    this.on('click', this.handleClick);
  }

  handleClick() {
    const varCat = this.element.getAttribute('data-var-cat');
    const varAct = this.element.getAttribute('data-var-act');
    const varLbl = document.URL;
    // eslint-disable-next-line no-undef
    dataLayer.push({
      event: 'fgWebAnalytics',
      fgVarCat: `${varCat}`,
      fgVarAct: `${varAct}`,
      fgVarLbl: `${varLbl}`,
    });
  }
}

export default DataLayer;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/DataLayer.js